import { EMPTY_OBJECT } from 'commons-ui';
import { DASHBOARD_RESOURCES } from 'constant';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `/dashboard/${DASHBOARD_RESOURCES.happyHour}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: `/dashboard/${DASHBOARD_RESOURCES.happyHour}/clone`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: `/dashboard/${DASHBOARD_RESOURCES.happyHour}/create`,
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
